import {
  blue,
  cyan,
  geekblue,
  generate,
  gold,
  green,
  lime,
  magenta,
  presetPalettes,
  purple,
  red,
  volcano,
  yellow
} from '@ant-design/colors'
import { Col, ColorPicker, Form, Row, theme } from 'antd'

import { useStyles } from './styles'

import type { ColorPickerProps, FormItemProps } from 'antd'

type Presets = Required<ColorPickerProps>['presets'][number]

const genPresets = (presets = presetPalettes) =>
  Object.entries(presets).map<Presets>(([label, colors]) => ({
    label,
    colors,
    key: label
  }))

type Props = {
  itemProps?: FormItemProps
} & ColorPickerProps & {
    name?: string
    initialValue?: string
  }

export const FormColorPicker = ({
  itemProps,
  name = 'color',
  initialValue,
  ...colorPickerProps
}: Props) => {
  const { token } = theme.useToken()
  const { styles } = useStyles()

  const presets = genPresets({
    primary: generate(token.colorPrimary),
    red,
    volcano,
    green,
    lime,
    yellow,
    gold,
    blue,
    geekblue,
    cyan,
    purple,
    magenta
  })

  const customPanelRender: ColorPickerProps['panelRender'] = (
    _,
    { components: { Picker, Presets } }
  ) => (
    <Row gutter={16} justify="space-between" wrap={false}>
      <Col span={12}>
        <Picker />
      </Col>

      <Col span={12} className={styles.colorPicker}>
        <Presets />
      </Col>
    </Row>
  )

  return (
    <Form.Item
      name={name}
      initialValue={initialValue || token.colorPrimary}
      getValueFromEvent={(color) => color.toHexString()}
      {...itemProps}
    >
      <ColorPicker
        presets={presets}
        format="hex"
        showText
        panelRender={customPanelRender}
        disabledAlpha
        {...colorPickerProps}
      />
    </Form.Item>
  )
}
